/**
 * Created by chenzheyu on 2017/6/19.
 */
import XKcheckInput from './src/checkInput.vue'

XKcheckInput.install = function (Vue) {
  Vue.component(XKcheckInput.name, XKcheckInput)
}

export default XKcheckInput



// WEBPACK FOOTER //
// ./src/components/module/checkInput/index.js